export default {"src":"/_next/static/media/dashboard.35711409.svg","height":2500,"width":2500,"blurWidth":0,"blurHeight":0};